module.exports = __webpack_public_path__ + "advisory-8c397925/deckblatt-fuer-die-bewerbung-gestal-b229d8e79d3d780c572714207484e4c9.jpeg";